<script>
export default {
  name: "CloseComponent",

  data() {
    return {
      componentOpen: false,
    }
  },
  methods: {
    toggleComponent() {
      // console.log("@mixin closecomponent toggleing from ", this.componentOpen, "to", !this.componentOpen);
      this.componentOpen = !this.componentOpen;
    },
    closeComponent(e) {
      // console.log("@mixin closecomponent element: ", this.$el);
      if (!this.$el.contains(e.target)) {
        this.componentOpen = false;
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.closeComponent);
  },
  beforeDestroy() {
    // console.log("@mixin closecomponent destroying!");
    document.removeEventListener('click',this.closeComponent);
  }
}
</script>